module.exports = __webpack_public_path__ + "img/luqei_integral.ab95a3bf.jpg";